const IconInstagram = ({
  width = "30",
  height = "30",
  fill = "url(#paint0_linear_6765_67)",
  fill2 = "#fff",
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      data-name="IconInstagram"
      className={className ? className : null}
    >
      <path
        d="M2.43519 2.55688C0.170654 4.90907 0.634127 7.40774 0.634127 14.9986C0.634127 21.3023 -0.465721 27.6216 5.29047 29.1093C7.08793 29.5716 23.0141 29.5716 24.8092 29.1069C27.2058 28.4886 29.1557 26.5446 29.4223 23.155C29.4595 22.6819 29.4595 7.32369 29.4211 6.84101C29.1377 3.23048 26.9152 1.14965 23.9867 0.728206C23.3155 0.630948 23.181 0.602131 19.7374 0.596128C7.52258 0.602131 4.84501 0.0582108 2.43519 2.55688Z"
        fill={fill}
      />
      <path
        d="M15.0403 4.36525C10.6805 4.36525 6.54046 3.97742 4.95913 8.03581C4.30595 9.712 4.4008 11.8889 4.4008 15.0059C4.4008 17.7411 4.31315 20.3118 4.95913 21.9748C6.53686 26.0356 10.7105 25.6466 15.0379 25.6466C19.2127 25.6466 23.5173 26.0812 25.1178 21.9748C25.7722 20.2818 25.6761 18.1374 25.6761 15.0059C25.6761 10.8491 25.9055 8.16549 23.8895 6.1507C21.8483 4.1095 19.0879 4.36525 15.0355 4.36525H15.0403ZM14.0869 6.28278C23.1811 6.26837 24.3385 5.25738 23.6998 19.302C23.4728 24.2694 19.6906 23.7242 15.0415 23.7242C6.56447 23.7242 6.32073 23.4817 6.32073 15.0011C6.32073 6.42206 6.99313 6.28758 14.0869 6.28038V6.28278ZM20.7196 8.04902C20.0148 8.04902 19.4433 8.62055 19.4433 9.32537C19.4433 10.0302 20.0148 10.6017 20.7196 10.6017C21.4244 10.6017 21.996 10.0302 21.996 9.32537C21.996 8.62055 21.4244 8.04902 20.7196 8.04902ZM15.0403 9.5415C12.0229 9.5415 9.57705 11.9885 9.57705 15.0059C9.57705 18.0233 12.0229 20.4691 15.0403 20.4691C18.0576 20.4691 20.5023 18.0233 20.5023 15.0059C20.5023 11.9885 18.0576 9.5415 15.0403 9.5415ZM15.0403 11.459C19.729 11.459 19.735 18.5528 15.0403 18.5528C10.3527 18.5528 10.3455 11.459 15.0403 11.459Z"
        fill={fill2}
      />
      <linearGradient
        id="paint0_linear_6765_67"
        x1="2.49044"
        y1="27.5725"
        x2="29.2728"
        y2="4.39274"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDD55" />
        <stop offset="0.5" stopColor="#FF543E" />
        <stop offset="1" stopColor="#C837AB" />
      </linearGradient>
    </svg>
  );
};
export default IconInstagram;
